import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView } from '@uirouter/react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_CREATE, PERMISSION_OBJ_CONTRACT_LINE_ITEM } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { contractLineItemStore } from '@/stores';
import { useMassUpdateCashedStores } from '@/utils/store';

import { columns } from './setup';

const entity = 'contract-line-items';
const store = contractLineItemStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_CONTRACT_LINE_ITEM, PERMISSION_CREATE]])(({ onClick }: any) => {
  return (
    <Button onClick={onClick} type="primary" icon={<FontAwesomeIcon icon={faPlus} />}>
      &nbsp;&nbsp;
      <FormattedMessage id="contract-line-items.add-new" />
    </Button>
  );
});

export const ContractLineItems = observer(({ transition }: any) => {
  const items = store.items;

  useMassUpdateCashedStores([store]);

  const onAdd = () => {
    transition.router.stateService.go(`base-layout.${entity}.create`);
  };

  return (
    <>
      <CreateButton onClick={onAdd} />
      <Table rowKey="id" bordered={true} columns={columns} dataSource={[...items]} store={store} scroll={{ x: 1500 }} />
      <UIView />
    </>
  );
});
